

$(function() {
	$('body').toggleClass('cookies-disabled', !navigator.cookieEnabled);
});
